import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const saveVoucher = async (payload, dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify(payload);
    const res = await axios.post("/api/voucher", body, config);
    successAlertHandle("Voucher added successfully!", dispatch);
  } catch (err) {
    errorAlertHandle(err, dispatch);
  }
};

export const getVoucherReport = createAsyncThunk(
  "app/getVoucherReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/voucher/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getVoucherApprovalReport = createAsyncThunk(
  "app/getVoucherApprovalReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/voucher-approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getVoucherAuthenticateReport = createAsyncThunk(
  "app/getVoucherAuthenticateReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/voucher-authenticate/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);
export const getVoucherByApproval = createAsyncThunk(
  "app/getVoucherByApproval",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/voucher/approval/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const updateVoucherByApproval = createAsyncThunk(
  "app/updateVoucherByApproval",
  async ({ data, redirectPath }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/voucher/approval`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      window.location.href = `/app#/${redirectPath}`;
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getVoucherByAuthenticate = createAsyncThunk(
  "app/getVoucherByAuthenticate",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/voucher/authenticate/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const updateVoucherByAuthenticate = createAsyncThunk(
  "app/updateVoucherByAuthenticate",
  async ({ data, redirectPath }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        ...data,
        pin: base64.encode(data.pin),
        otp: base64.encode(data.otp),
      });
      const res = await axios.put(`/api/voucher/authenticate`, body, config);
      successAlertHandle("Action updated successfully", dispatch);
      window.location.href = `/app#/${redirectPath}`;
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// export const exportVoucherReport = async ({ filters, type }) => {
//   try {
//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     };
//     const body = JSON.stringify({
//       ...filters,
//       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//     });
//     const res = await axios.post(`/api/download/${type}/filter`, body, config);
//     return res.data;
//   } catch (err) {
//     throw err;
//   }
// };
